import { Modal } from "react-bootstrap";
import { useState } from "react";
import { alertWithSuccessMessage } from "components/modal/success_modal";
import { GetUdiamondAllResponse } from "lib/worker/api/get_udiamond_all";
import exchange_sm_point from "lib/worker/api/exchange_sm_point";
import { MaxButton, StatusMaxButton } from "components/view/button";
import getinfo from "lib/worker/api/getinfo";
import { alertWithMessage } from "./message_modal";

interface CheckOutModalProps {
  handleClose?: Function | undefined;
  handleExchangeSuccuess: Function;
  show: boolean | undefined;
  selectUDiamond: GetUdiamondAllResponse | undefined;
}

function UDiamondModal(props: CheckOutModalProps) {
  const { show, handleClose, handleExchangeSuccuess, selectUDiamond } = props;
  const [spinner, setSpiner] = useState<boolean>(false);

  const handleSubmit = () => {
    setSpiner(true);
    exchange_sm_point({ id: selectUDiamond?.ID })
      .then(() => {
        setSpiner(false);
        handleExchangeSuccuess();
        getinfo();
        alertWithSuccessMessage("แลกสำเร็จ");
      })
      .catch((error) => {
        setSpiner(false);
        handleExchangeSuccuess();
        alertWithMessage(error.response.data.message);
      });
  };

  return (
    <Modal
      {...props}
      size="lg"
      scrollable={true}
      contentClassName="view-background-black"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={() => {
        if (handleClose) {
          handleClose();
        }
      }}
      dialogClassName="modal-alert"
    >
      <Modal.Header closeButton className="modal-header">
        <Modal.Title id="example-modal-sizes-title-lg">
          <div className="text-title center-row-content">
            <span>ยืนยันแลก uDiamond</span>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 col-md-6 center-row-content grid">
          <div className="border-radius border-ufa-grey shadow">
            <div className="card-udiamond">
              <div className="heading margin-left-10 margin-right-10">
                <div className="font-bold text-center">
                  {selectUDiamond?.AmountUdiamond?.format(0, 0)} uDiamond
                </div>
                <p className="bottom-line-yellow"></p>
              </div>
              <div className="card-body text-center">
                <div className="font-linear font-bold">
                  {selectUDiamond?.AmountCredit?.format(0, 0)} บาท
                </div>
                <small>( 300 uDiamond = 1 บาท )</small>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 margin-top-20">
          <MaxButton
            title="ยืนยัน"
            status={StatusMaxButton.submit}
            loading={spinner}
            onClick={handleSubmit}
          ></MaxButton>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
}

export default UDiamondModal;
